export class DispatchSummary {
  constructor(dispatchId: any, number: string, status: string) {
    this.dispatchId = dispatchId;
    this.number = number;
    this.status = status;
  }
  dispatchId: any;
  number: string;
  status: string;
  priority: any;
  priorityColor: any;
}
